import React from 'react';
import PropTypes from 'prop-types';
var LoaderContext = /*#__PURE__*/React.createContext({
  isLoaded: function isLoaded() {},
  start: function start() {},
  stop: function stop() {}
});
export default LoaderContext;
export var loaderContextShape = {
  isLoaded: PropTypes.func.isRequired,
  start: PropTypes.func.isRequired,
  stop: PropTypes.func.isRequired
};